import { Modifier } from "@/apps/shared/proposal/core/domain/model/Modifier";

export class PaymentMethod {
  public readonly id: string;
  public readonly type: string;
  public readonly description: string;
  public readonly longDescription: string;
  public readonly modifier: Modifier | null;
  public iban: string | null = null;
  public readonly label: string;

  constructor(
    id: string,
    type: string,
    description: string,
    longDescription: string,
    modifier: Modifier | null,
    label: string = ""
  ) {
    this.id = id;
    this.type = type;
    this.description = description;
    this.longDescription = longDescription;
    this.modifier = modifier;
    this.label = label;
  }

  /**
   * @deprecated This should not be done in the domain
   */
  getJsonLdId(): string {
    return `/payment-modes/${this.id}`;
  }

  setIban(iban: string): void {
    this.iban = iban;
  }

  getType(): string {
    return this.type;
  }
}
